export const DriverStatuses: { [index: number]: string } = {
  0: 'REST',
  1: 'AVAILABILITY',
  2: 'WORK',
  3: 'RIDE',
  4: 'CARD_WITHDRAWAL',
  5: 'STATUS_UNKNOWN',
};
